import { createSelector } from "reselect";
import get from "lodash/get";
import { REPORT_FRAUD_REASON, forms } from "utils/constants";
import {
  formValuesSelector,
  orderRefSelector,
  sessionTokenSelector
} from "ducks/selectors";

// ***************************************************************
// ************** reportFraudForm selectors ******************
// ***************************************************************

export const reportFraudSelector = formValuesSelector(forms.REPORT_FRAUD_FORM);

// ***************************************************************
// *************** reportFraudForm makeSelect *******************
// ***************************************************************

export const makeSelectReportFraudForm = () => reportFraudSelector;

export const makeSelectReportFraudPayload = () =>
  createSelector(
    reportFraudSelector,
    orderRefSelector,
    sessionTokenSelector,
    (reportFraud, order_ref, session_token) => {
      return {
        order_ref,
        session_token,
        sim_type: "ESIM",
        reason: REPORT_FRAUD_REASON,
        nric: get(reportFraud, "nric")
      };
    }
  );
